import React, { useEffect, useState } from "react";
import { Header } from '@appkit4/react-components/header';
import { Avatar } from '@appkit4/react-components/avatar';
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Button } from '@appkit4/react-components/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

interface ChatPageInputs {
    name: string
}

const Navbar: React.FC<ChatPageInputs> = ({ name }) => {
    const accessToken = useSelector((state: RootState) => state.auth.accessToken)
    const [userName, setUsername] = useState('')
    const navigate = useNavigate();

    const handleLogout = () => {
        navigate('/logout')
    };

    useEffect(() => {
        if (accessToken) {
            const arrayToken = accessToken.split('.');
            const tokenPayload = JSON.parse(atob(arrayToken[1]));
            setUsername(tokenPayload?.name[0])
        }
    }, [accessToken])

    const onClickLogo = (event: React.MouseEvent<HTMLElement>) => {
    }
    return (
        <div className="header-demo-wrapper">
            <Header
                type="transparent"
                compact={false}
                onClickLogo={onClickLogo}
                titleTemplate={() => "Pensions Digital Assistant"}
                userTemplate={() => (<div style={{ display: 'flex', alignItems: 'center' }}>
                    {accessToken ? <><Button
                        kind="primary"
                        onClick={handleLogout}
                        style={{ marginRight: '10px' }}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                    </Button>
                        <Avatar label={userName} role="button" disabled={false}></Avatar></> : <></>}
                </div>)}>
            </Header>
        </div>
    );
}
export default Navbar;